"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intlDefault = void 0;
var _LangInfo = require("./LangInfo");
const intlDefault = exports.intlDefault = {
  language: _LangInfo.langInfoDefault,
  translations: {},
  translate: id => id
};